
import { Component, Vue } from "vue-property-decorator";
import { MetaInfo } from "vue-meta";
import Breadcrumb from "@/components/Utility/Breadcrumb.vue";
@Component({
  components: { Breadcrumb },
})
export default class QApage extends Vue {
  metaInfo(): MetaInfo {
    return {
      title: "常見問題 Q&A｜師虎來了使用說明與服務保障",
      meta: [
        {
          vmid: "description",
          name: "description",
          content:
            "關於帳號註冊、下訂流程、付款方式與售後保固，師虎來了整理常見問題集，協助您快速了解修繕媒合服務的使用方式與保障內容。",
        },
        {
          vmid: "og:title",
          property: "og:title",
          content: "常見問題 Q&A｜師虎來了使用說明與服務保障",
        },
        {
          vmid: "og:description",
          property: "og:description",
          content:
            "關於帳號註冊、下訂流程、付款方式與售後保固，師虎來了整理常見問題集，協助您快速了解修繕媒合服務的使用方式與保障內容。",
        },
      ],
      link: [
        {
          vmid: "canonical",
          rel: "canonical",
          href: "https://www.fdtigermaster.com/QA",
        },
      ],
    };
  }
}
